import * as React from 'react';
import { useDispatch } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { prefillShippingForms } from '../actions.js';

const useFormPrefill = (userData)=>{
    const checkoutSettings = useCheckoutSettings();
    const shippingDetailsCart = checkoutSettings.shippingDetails;
    const dispatch = useDispatch();
    React.useEffect(()=>{
        if ((shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.loadingFinished) && userData.status !== 'loading') {
            dispatch(prefillShippingForms({
                userData,
                cartData: shippingDetailsCart,
                fields: checkoutSettings.shippingFormFields
            }));
        }
    // We don't want this effect to trigger every time the shippingDetailsCart is updated,
    // only once when the forms are ready
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.loadingFinished,
        userData.status
    ]);
};

export { useFormPrefill };
//# sourceMappingURL=use-form-prefill.js.map
